module.exports = __webpack_public_path__ + "img/we-got-a-problem.ca6cf32a.svg";